import styled from 'styled-components';

export const BoxCard = styled.div`
  background: #fff;
  border-radius: 4px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.08);
  margin-top: 24px;
  padding: 24px;
`;

export const Status = styled.span<{ active: boolean }>`
  color: ${({ active }) => (active ? '#168821' : '#e71037')};
  font-weight: 600;
`;
